var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCat = function SvgCat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.286 35.143h3.428m-24 10.286 12-6.858m-12-10.285 13.715 3.428M25.646 7.817l18.48-5.177a1.58 1.58 0 0 1 1.577.377 1.68 1.68 0 0 1 .548 1.543L42.48 23.794a22 22 0 0 1-.583-1.611A19.71 19.71 0 0 0 24 7.714 19.71 19.71 0 0 0 6.103 22.183c-.172.583-.377 1.097-.583 1.646L1.749 4.56a1.68 1.68 0 0 1 .548-1.543 1.58 1.58 0 0 1 1.577-.377l18.48 5.177m6.789 37.029a23 23 0 0 1-10.286 0m27.429.583-12-6.858m12-10.285L32.57 31.714"
  })));
};
export default SvgCat;